import { useEffect } from "react";
import axios from "axios";
import use123zapStore from "../../../context/123zapStore";
import { getTokenData } from "../../../shared/utils/utils";

export default function useDashboard() {
  const {
    dashboardSentiments,
    dashboardTotalMessages,
    dashboardLoading,
    dashboardLoaded,
    setDashboardData,
    setDashboardLoading,
  } = use123zapStore();

  useEffect(() => {
    if (dashboardLoaded || dashboardLoading) return;

    const loadDashboard = async () => {
      try {
        setDashboardLoading(true);

        const { token, client_id } = await getTokenData();
        const url = process.env.REACT_APP_BACKEND_AWS_URL;

        const response = await axios.get(
          `${url}/dashboard/messages/received/comprehend`,
          {
            headers: {
              Authorization: token,
              client_id,
            },
          }
        );

        setDashboardData(
          response.data.data["Sentimentos Gerais"],
          response.data.data["Total de Mensagens"] || 0
        );
      } catch (error) {
        console.error("Erro ao carregar dashboard:", error);
      } finally {
        setDashboardLoading(false);
      }
    };

    loadDashboard();
  }, [dashboardLoaded, dashboardLoading, setDashboardData, setDashboardLoading]);

  return {
    sentiments: dashboardSentiments,
    totalMessages: dashboardTotalMessages,
    loading: dashboardLoading,
  };
}